import { PermissionType } from '../contracts/permissions.js';
// `PermissionType` is now a Zod enum; `.options` gives the underlying tuple array.
const permissionTypes = PermissionType.options;
export function getLeastPrivilegedPermission(...permissions) {
    return permissionTypes[permissions
        .values()
        .map((x) => (x === null || x === undefined ? -1 : permissionTypes.indexOf(x)))
        .min()];
}
export function getMostPrivilegedPermission(...permissions) {
    return permissionTypes[permissions
        .values()
        .map((x) => (x === null || x === undefined ? -1 : permissionTypes.indexOf(x)))
        .max()];
}
/**
 * @deprecated this method should almost never be used, prefer `doesAccessGrantAllowRequest`
 */
export function comparePermissions(a, b) {
    const aIdx = a ? permissionTypes.indexOf(a) : -1;
    const bIdx = b ? permissionTypes.indexOf(b) : -1;
    return aIdx - bIdx;
}
export function doesAccessGrantAllowRequest(grant, request) {
    if (!grant)
        return false;
    if (!request)
        return true;
    return permissionTypes.indexOf(grant) >= permissionTypes.indexOf(request);
}
export function getPermissionSetTypeForPermissionType(type) {
    return `${type}s`;
}
export function getPermissionTypeForPermissionSetType(type) {
    return type.slice(0, -1);
}
export const permissionSetTypes = Object.freeze(permissionTypes.map((x) => getPermissionSetTypeForPermissionType(x)));
//# sourceMappingURL=permissions.js.map